import { CountUp } from 'countup.js';
import scrollMonitor from 'scrollmonitor';

import bus from '../util/eventBus';

const itemsToCount = document.querySelectorAll(
  '.c-fact__value:not(.c-fact__value--no-count)',
);
const { lang } = document.documentElement.attributes;
const isGer = lang.value === 'de-DE';

if (itemsToCount) {
  itemsToCount.forEach(value => {
    const elWatcher = scrollMonitor.create(value, { top: -100 });

    elWatcher.one('enterViewport', () => {
      const valueEl = Number(value.innerText);
      const countValue = new CountUp(value, valueEl, {
        duration: 3,
        separator: isGer ? '.' : ',',
        decimal: isGer ? ',' : '.',
      });
      countValue.start(() => bus.emit('ewg-count-complete'));
    });
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/count.js